export default "__VITE_ASSET__DH7uLSGX__"